export function heroMediaAdaptiveBg() {
    let $parent = $(".hero-section.with-media");
    let bg = $parent.find(".hero-bg");
    let mediaBlock = $parent.find(".hero-media-block");
    let infoBlock = mediaBlock.closest(".hero-media").find(".result-numbers-item");
    let infoBlockHeight = 0;
    let $win = $(window);

    let setBgHeight = function () {
        if (mediaBlock.length) {
            if (infoBlock.length) {
                infoBlockHeight = infoBlock.innerHeight() / 2
                infoBlock.css('margin-top', -infoBlockHeight)
            }

            let distance = $(mediaBlock).height() / 2 + infoBlockHeight;

            $(bg).css({
                "height": "calc(100% - " + Math.round(distance) + "px)"
            })
        }
    };

    if ($win.width() >= 768) {
        setBgHeight();
    }

    $win.on("resize", function () {
        if ($win.width() >= 768) {
            setBgHeight();
        } else {
            $(bg).css({
                "height": "100%"
            });
            infoBlock.css('margin-top', 40);
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/heroMediaAdaptiveBg.js